import { Dictionary } from "@reduxjs/toolkit";
import { FetchedDetail, FetchedTimestamp, RequestState, UseFetchRefs } from "../dataTypes";

const mapUseFetchRefs = (state: Dictionary<FetchedTimestamp & { requestState?: RequestState } & FetchedDetail>) => {
  return Object.entries(state).reduce((result, [id, object]) => {
    result[id] = object
      ? {
          hasFetchedDetail: object.hasFetchedDetail,
          fetchedTimestamp: object.fetchedTimestamp,
          requestState: object.requestState,
        }
      : undefined;

    return result;
  }, {} as UseFetchRefs);
};

export default mapUseFetchRefs;
